// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["vendors-node_modules_microsoft_fetch-event-source_lib_cjs_parse_js-node_modules_babel-polyfil-f812c9"], () => (__webpack_require__("./node_modules/babel-polyfill/lib/index.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_microsoft_fetch-event-source_lib_cjs_parse_js-node_modules_babel-polyfil-f812c9"], () => (__webpack_require__("./assets/src/jsx/index.jsx")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
